<div class="wrapper-content-item-details">
    <div *ngIf="singleItem?.is_single_item_group" class="wrapper-content-single-details">
        <div class="header-single-details">
            <img class="item-img" [src]="singleItem?.items[0]?.lyst_item_image_url ? singleItem?.items[0]?.lyst_item_image_url : 'assets/images/no-image.png'" alt="">
            <span class="item-name">{{singleItem?.items[0]?.name}}</span>
            <span class="item-by">{{singleItem?.items[0]?.by}}</span>
            <div class="wrapper-rating">
                <app-item-rating [averageRating]="singleItem?.items[0]?.average_rating"
                [reviewsCount]="singleItem?.items[0]?.reviews_count"></app-item-rating>
            </div>
            <button [routerLink]="[PAGES_AND_PATHS.singleItem.pagePath, singleItem.items[0].id]" class="custom-btn custom-btn--primary">
                <span>
                    {{'NEAR_YOU_PAGE.view_details' | translate}}
                </span>
            </button>
            <button (click)="confirmModal.emit(true)" class="custom-btn custom-btn--gray">
                <span>
                    {{'NEAR_YOU_PAGE.get_directions' | translate}}
                </span>
            </button>
            <div class="line-gray"></div>
        </div>
        <div class="content-single-details">
            <div class="title-list-preview">
                {{'NEAR_YOU_PAGE.item_also_seen_in_lists' | translate}}
            </div>
            <div *ngFor="let list of singleItem?.items[0]?.relatedLysts" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']" class="wrapper-list-preview">
                <div class="wrapper-image-list">
                    <img [src]="list?.lyst_image_url ? list?.lyst_image_url : 'assets/images/no-image.png'" alt="">
                </div>
                <div class="wrapper-info-list">
                    <div class="title-list">
                        <span>{{list | matchLocale}} </span>
                        <span class="label-item">{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('LISTS.items' |translate) : ('LISTS.items' |translate)}}</span>
                    </div>
                    <span class="time-list">{{list.updated_at | timeAgo}}</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!singleItem?.is_single_item_group" class="wrapper-content-single-details">
        <div class="header-single-details">
            <img class="item-img" [src]="singleItem?.lyst_item_image_url ? singleItem?.lyst_item_image_url : 'assets/images/no-image.png'" alt="">
            <span class="item-name">{{singleItem?.name}}</span>
            <span class="item-by">{{singleItem?.by}}</span>
            <div class="wrapper-rating">
                <app-item-rating [averageRating]="singleItem?.average_rating"
                [reviewsCount]="singleItem?.reviews_count"></app-item-rating>
            </div>
            <button [routerLink]="[PAGES_AND_PATHS.singleItem.pagePath, singleItem.id]" class="custom-btn custom-btn--primary">
                <span>
                    {{'NEAR_YOU_PAGE.view_details' | translate}}
                </span>
            </button>
            <button (click)="confirmModal.emit(true)" class="custom-btn custom-btn--gray">
                <span>
                    {{'NEAR_YOU_PAGE.get_directions' | translate}}
                </span>
            </button>
            <div class="line-gray"></div>
        </div>
        <div class="content-single-details">
            <div class="title-list-preview">
                {{'NEAR_YOU_PAGE.item_also_seen_in_lists' | translate}}
            </div>
            <div *ngFor="let list of singleItem?.relatedLysts" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']" class="wrapper-list-preview">
                <div class="wrapper-image-list">
                    <img [src]="list?.lyst_image_url ? list?.lyst_image_url : 'assets/images/no-image.png'" alt="">
                </div>
                <div class="wrapper-info-list">
                    <div class="title-list">
                        <span>{{list | matchLocale}} </span>
                        <span class="label-item">{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('LISTS.items' |translate) : ('LISTS.items' |translate)}}</span>
                    </div>
                    <span class="time-list">{{list.updated_at | timeAgo}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
